__turbopack_context__.v({
  "active": "styles-module-scss-module__BtoSPW__active",
  "card": "styles-module-scss-module__BtoSPW__card",
  "disabled": "styles-module-scss-module__BtoSPW__disabled",
  "enter": "styles-module-scss-module__BtoSPW__enter",
  "exit": "styles-module-scss-module__BtoSPW__exit",
  "fade-in": "styles-module-scss-module__BtoSPW__fade-in",
  "fade-out": "styles-module-scss-module__BtoSPW__fade-out",
  "fade-out-80": "styles-module-scss-module__BtoSPW__fade-out-80",
  "icon": "styles-module-scss-module__BtoSPW__icon",
  "slide-in-from-bottom": "styles-module-scss-module__BtoSPW__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__BtoSPW__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__BtoSPW__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__BtoSPW__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__BtoSPW__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__BtoSPW__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__BtoSPW__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__BtoSPW__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__BtoSPW__zoom-in",
  "zoom-out": "styles-module-scss-module__BtoSPW__zoom-out",
});
